import React, { useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/autoplay'; // Import autoplay styles if required
import './Chaptercard.css';
import Navbar from '../Components/Navbar';
import Languages from './Languages';
import { Autoplay } from 'swiper/modules'; // Correct import for Autoplay module

import HAPPYFAMILY from '../images/HAPPYFAMILY.webp';
import GENERALCHAP from '../images/ATRIIMG.png';
import SIBLINGS from '../images/SIBLINGS.jpg';
import PROPERTY from '../images/PROPERTY.jpg';
import PRGNANT from '../images/PRGNANT.avif';
import HEALTHY from '../images/HEALTHY.jpg';
import MARRIAGE from '../images/MARRIAGE.jpg';
import HUMANGROW from '../images/HUMANGROW.jpg';
import COINFALLING from '../images/COINFALLING.jpg';
import BUSINESSIMG from '../images/BUSINESSIMG.jpg';
import MONEYPROFIT from '../images/MONEYPROFIT.avif';
import TRIPWAIT from '../images/TRIPWAIT.jpg';
import BIRTHSIN from '../images/BIRTHSIN.jpg';
import JEPAMANTRA from '../images/JEPAMANTRA.jpeg';

const chapters = [
  { title: 'General Overview (Janma Kandam)', desc: 'Offers a summary...', img: GENERALCHAP },
  { title: 'Family, Wealth, and Education (Kutumba Kandam)', desc: 'Details financial...', img: HAPPYFAMILY },
  { title: 'Siblings (Sahodara Kandam)', desc: 'Describes the...', img: SIBLINGS },
  { title: 'Mother, Assets, and Happiness (Matrukara Kandam)', desc: 'Explores the...', img: PROPERTY },
  { title: 'Children and Progeny (Santana Kandam)', desc: 'Focuses on...', img: PRGNANT },
  { title: 'Health and Enemies (Roga and Runa Kandam)', desc: 'Covers health...', img: HEALTHY },
  { title: 'Marriage (Kalathra Kandam)', desc: 'Delves into...', img: MARRIAGE },
  { title: 'Longevity and Accidents (Ayul Kandam)', desc: 'Discusses life span...', img: HUMANGROW },
  { title: 'Father, Wealth, and Spirituality (Pithru Kandam)', desc: 'Covers the father\'s...', img: COINFALLING },
  { title: 'Profession and Business (Karma Kandam)', desc: 'Provides insights...', img: BUSINESSIMG },
  { title: 'Profits and Second Marriage (Labha Kandam)', desc: 'Analyzes financial...', img: MONEYPROFIT },
  { title: 'Losses and Expenditure (Vyaya Kandam)', desc: 'Predicts losses...', img: TRIPWAIT },
  { title: 'Santhi Pariharam', desc: 'Last birth sins...', img: BIRTHSIN },
  { title: 'Deeksha Kandam', desc: 'Manthra japam...', img: JEPAMANTRA },
];

export default function Chaptercard() {
  const swiperRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <section id="nadi-astrology">
        <h2 id="chaps">The 16 Chapters of Nadi Astrology: A Detailed Insight</h2>
        <p className="intro">
          Nadi Astrology provides intricate insights into various aspects of life, guiding individuals with remedies and understanding past, present, and future lives. Explore the detailed chapters below.
        </p>
        
        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          loop={true}
          ref={swiperRef}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          modules={[Autoplay]}
          pagination={{ clickable: true }}
        >
          {chapters.map((chapter, index) => (
            <SwiperSlide key={index}>
              <div className="chapter">
                <div className="chapter-img">
                  <img src={chapter.img} alt={chapter.title} className="img-fluid" width={400} height={400} />
                </div>
                <div className="chapter-content">
                  <h3>{chapter.title}</h3>
                  <p>{chapter.desc}</p>
                  <Link to='/Chapters'>
                    <button className="appointment-btn">Read More</button>
                    </Link>
                  {/* <h6 className="m-4" style={{ display: 'inline-block', marginRight: '10px' }}>Swipe Here</h6>
                  <span style={{ fontSize: '30px', marginTop: '5px', verticalAlign: 'middle' }} id="arrows">&#8651;</span> */}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      
    </>
  );
}
